import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_5: FaireProductEntity = {
  token: "nyc-soap-5",
  type: "product",
  name: "Coconut Milk Bath Soak",
  brandName: "Spa Essentials",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4b4955ab73d7063dcdd78f8262fa0fc2c512b0c4250c3578bb527ee41b0e4ca7.webp",
  priceDollars: 16,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4b4955ab73d7063dcdd78f8262fa0fc2c512b0c4250c3578bb527ee41b0e4ca7.webp",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 2,
  },
  description: "Rose petal infused soap from Queens",
  categoryTokens: ["cat_bath-all"],
  tags: ["nyc-local", "premium", "organic", "floral"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
